<template>
    <q-card>
        <q-form @submit.prevent="executeUpdateOrganization">
            <q-card-section>
                <div class="text-h6">Редактировать организацию</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <q-input dense v-model="updateOrganization.name" label="Имя проекта"
                    :rules="[requiredRule, objectNameRule]" />
            </q-card-section>

            <q-card-actions align="right" class="text-primary">
                <q-btn no-caps flat label="Удалить" @click="deleteOrganization" color="negative" />
                <q-btn no-caps flat label="Обновить" type="submit" />
            </q-card-actions>
        </q-form>
    </q-card>
</template>

<script setup lang="ts">
import { useQuasar } from "quasar";
import { reactive, watch } from "vue";
import { useProjectStore } from "../store/project";
import { useRoute, useRouter } from "vue-router";
import { useDeleteOrganization, useOrganization, useUpdateOrganization } from "../composables/organization";
import { objectNameRule, requiredRule } from "../util/rules";
import { UpdateOrganization } from "../models/organization";
import { useRouteParams } from "@vueuse/router";


const $q = useQuasar()

const store = useProjectStore()

const organizationId = useRouteParams('organizationId', undefined, { transform: Number })


const { data: organization, isFetching: loading } = useOrganization(organizationId)


const route = useRoute()
const router = useRouter()

watch(organization, (val) => {
    if (val) {
        updateOrganization.name = val.name
    }
})

const updateOrganization = reactive<UpdateOrganization>({
    name: organization.value?.name ?? "",
})

const { execute } = useUpdateOrganization(organizationId, updateOrganization)

const { execute: executeDelete } = useDeleteOrganization(organizationId)

async function executeUpdateOrganization() {
    await execute(true)
}

async function deleteOrganization() {
    $q.dialog({
        title: 'Удаление',
        message: 'Для удаления введите имя организации',
        prompt: {
            model: '',
            isValid: val => val === organization.value?.name, // << here is the magic
            type: 'text' // optional
        },
        cancel: true,
        persistent: true
    }).onOk(async data => {
        if (data === organization.value?.name) {
            await executeDelete()
            await router.push('/organizations')
        }

    })

}

</script>

<style scoped></style>